module.exports = __webpack_public_path__ + "static/media/peyto.5160da4b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/backgrounds/peyto.png
 ** module id = 189
 ** module chunks = 0
 **/